import React, { FC, useState } from 'react'

import { EuiButton, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFlyoutBody, EuiFlyoutFooter, EuiFlyoutHeader, EuiFormRow, EuiTitle } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

interface EditBlueprintNameFlyoutProps {
  currentName: string
  onSave: (name: string) => Promise<void>
  onClose: () => void
  isLoading: boolean
}

const EditBlueprintNameFlyout: FC<EditBlueprintNameFlyoutProps> = ({ currentName, onSave, onClose, isLoading }) => {
  const [name, setName] = useState(currentName)

  const handleSave = async () => {
    await onSave(name.trim())
    onClose()
  }

  return (
    <AcFlyout onClose={onClose} size='s'>
      <EuiFlyoutHeader hasBorder>
        <EuiTitle size='m'>
          <h2>Edit Blueprint Name</h2>
        </EuiTitle>
      </EuiFlyoutHeader>
      <EuiFlyoutBody>
        <EuiFormRow label='Blueprint Name' fullWidth>
          <EuiFieldText fullWidth value={name} onChange={e => setName(e.target.value)} />
        </EuiFormRow>
      </EuiFlyoutBody>
      <EuiFlyoutFooter>
        <EuiFlexGroup direction='row' alignItems='center'>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose}>Cancel</EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={handleSave} isLoading={isLoading} disabled={!name.trim()}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default EditBlueprintNameFlyout
